export default __webpack_public_path__ + "static/media/048-hot tea.e4d7c97f.svg";